import './../css/_app.scss'
import nav from './nav';
import sliders from './sliders';
import listing from './listing';
import accordion from './accordion';
import CaseStudies from './CaseStudies';
import IframeLoader from './IframeLoader';
import multiTabSwitcher from "./multiTabSwitcher";
import ourTeamBio from "./ourTeamBio";

import VideoPopup from "./VideoPopup";

export default class App {
	constructor() {
		this.initBody();
	}

	initBody() {
		listing();
		accordion();
		nav.searchBox();
		nav.submenu();
	}

	initCore() {
		nav.hamburger();
		nav.langSwitcher();
		CaseStudies.init();
		VideoPopup.init();
		multiTabSwitcher.init();
		ourTeamBio.init();
	}
}


function LoadApp() {
	const app = new App();
	app.initCore();
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', LoadApp);
} else {
	LoadApp();
}

window.addEventListener('load', () => sliders());